import DeleteModal from './business-case-delete-modal';

export default DeleteModal;
